import { Controller } from "@hotwired/stimulus"

// Context hint — faixa de "para que serve / como funciona" logo abaixo do header.
//
// Dispensável: o "x" esconde a faixa e revela um ícone "?" discreto; clicar no
// "?" reabre a faixa. A escolha é lembrada em localStorage por `key` (uma chave
// por tela), então cada tela guarda seu próprio estado independente.
//
// CSP-safe: nenhum handler inline; tudo via data-action. O estado inicial é
// aplicado em connect() (não no HTML) para não gravar preferência no server.
//
// Targets:
//   banner → a faixa completa (com texto + botão x)
//   reopen → o botão-ícone "?" que reabre a faixa
export default class extends Controller {
  static targets = ["banner", "reopen"]
  static values  = { key: String }

  connect() {
    if (this._dismissed()) this._showReopen()
    else this._showBanner()
  }

  dismiss() {
    try {
      window.localStorage.setItem(this._storageKey(), "1")
    } catch (_e) {
      // localStorage indisponível (modo privado/quota): degrada para esconder
      // só nesta sessão, sem persistir. A dica volta no próximo load.
    }
    this._showReopen()
  }

  reopen() {
    try {
      window.localStorage.removeItem(this._storageKey())
    } catch (_e) {
      // idem dismiss: sem persistência, reabre só nesta sessão.
    }
    this._showBanner()
  }

  // Toggle via style.display (não classe "hidden"): o botão de reabrir usa
  // "inline-flex", que sobrescreveria ".hidden" do Tailwind (mesma propriedade,
  // ordem do stylesheet decide) e o deixaria visível mesmo com a classe. Setar
  // display inline é imune a essa colisão de classes.
  _showBanner() {
    this.bannerTarget.style.display = ""
    if (this.hasReopenTarget) this.reopenTarget.style.display = "none"
  }

  _showReopen() {
    this.bannerTarget.style.display = "none"
    if (this.hasReopenTarget) this.reopenTarget.style.display = ""
  }

  _dismissed() {
    try {
      return window.localStorage.getItem(this._storageKey()) === "1"
    } catch (_e) {
      return false
    }
  }

  _storageKey() {
    return `hint_dismissed:${this.keyValue}`
  }
}
